import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=552117ad&scoped=true&"
import script from "./knowledge.vue?vue&type=script&lang=js&"
export * from "./knowledge.vue?vue&type=script&lang=js&"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=552117ad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552117ad",
  null
  
)

export default component.exports